// 简单的滚动揭示逻辑
document.addEventListener('DOMContentLoaded', function() {
    const blocks = document.querySelectorAll('.timeline-block');
    const options = { threshold: 0.3 };

    const revealOnScroll = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.style.opacity = "1";
                entry.target.style.transform = "translateX(0)";
            }
        });
    }, options);

    blocks.forEach(block => {
        block.style.opacity = "0";
        block.style.transform = "translateX(20px)";
        block.style.transition = "0.6s all ease-out";
        revealOnScroll.observe(block);
    });
});